import { RegionType } from "graphql/generated";
import { CURRENCY_BY_COUNTRY } from "src/constants/currency";

import { checkCountry } from "./checkCountry";

export const formatDisplayPriceByRegion = (value: string) => {
  if (process.env.NEXT_PUBLIC_COUNTRY === RegionType.Jp) {
    return value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return value;
};

export const formatPrice = (price: number, isShowCurrency = true, fixed = 2) => {
  const currency = isShowCurrency ? CURRENCY_BY_COUNTRY[process.env.NEXT_PUBLIC_COUNTRY] : "";
  const newFixed = checkCountry([RegionType.Jp]) ? 0 : fixed;

  const divisor = checkCountry([RegionType.Hk, RegionType.Sg]) ? 100 : 1;

  const dividedPrice =
    price >= 0
      ? `${currency}${(price / divisor).toFixed(newFixed)}`
      : `-${currency}${((price * -1) / divisor).toFixed(newFixed)}`;
  return formatDisplayPriceByRegion(dividedPrice);
};
